<template>
  <div class="lyshowhide123456" :style="{ left, right }">
    <div class="lyshowhide123" @click="toggle">
      <Icon :type="show ? 'ios-arrow-up' : 'ios-arrow-down'" />
    </div>
    <div :class="{ hidden: !show }" :style="{ height: show ? 'auto' : 0 }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["left", "right"],
  data() {
    return {
      show: true,
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};
</script>
<style lang="">
.lyshowhide123456 {
  position: absolute;
  top: 0;
  z-index: 2;
}
.lyshowhide123 {
  width: 40px;
  height: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  margin: 0 auto;
  border-radius: 0 0 10px 10px;
  text-align: center;
  cursor: pointer;
  line-height: 1;
}
.lyshowhide123:hover {
  background: #658bff;
  color: #fff;
}
.hidden {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/common/showHide.vue